export default __webpack_public_path__ + "static/media/latest-news-img26.75df51b8.jpg";